export default __webpack_public_path__ + "static/media/secondsteplg.9348ac3c.png";